const closeButtonLabel = "Lukk";
const nbNO = {
  closeButtonLabel
};
export {
  closeButtonLabel,
  nbNO as default
};
